import { render } from "./DeviceCard.vue?vue&type=template&id=dbde0a98&scoped=true"
import script from "./DeviceCard.vue?vue&type=script&lang=js"
export * from "./DeviceCard.vue?vue&type=script&lang=js"

import "./DeviceCard.vue?vue&type=style&index=0&id=dbde0a98&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\timdi\\Desktop\\funkapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbde0a98"]])

export default __exports__